import React from 'react';
import ReactDOM from 'react-dom';
// import axios from 'axios';

import {Link,} from 'react-router';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import './adyen.css';
import '../../public/css/media/_checkout.scss';
import Footer from './Layout/Footer/Footer';
import { getPaymentMethods, removeAdyenCard } from '../services/adyenService';
import { handleEnvironment } from '../utils/utils';
/* eslint-disable */
const appConfig = require('webpack-config-loader!../app-config.js');
const adyenClientKey = appConfig.adyenDropIn;
/* eslint-enable */


const createReactClass = require('create-react-class');
// this.paymentContainer = React.createRef();

const AdyenPayment = createReactClass({
    getInitialState() {
        return {
          isLoaderShown: false
        };
    },
    componentDidMount() {

      getPaymentMethods(this.props.login.login.party.account_number).then((res)=> {
        this.mountAdyenCheckout({methods:res.data})
      })
    },
    async mountAdyenCheckout({methods}) {
      try {
        const configuration = {
          paymentMethodsResponse: methods, // The `/paymentMethods` response from the server.
          clientKey: adyenClientKey, // Web Drop-in versions before 3.10.1 use originKey instead of clientKey.
          locale: 'en-US',
          environment: handleEnvironment(),
          translations: {
            'en-US': {
              'storedPaymentMethod.disable.confirmButton': 'Yes',
              'storedPaymentMethod.disable.cancelButton': 'No',
            }
          },
          onSubmit: async (state, dropin) => {
            this.setState({isLoaderShown: true})
            this.props.checkOutAdyenDropin({formData:state, checkoutDetails: {...this.props.customerCheckout.checkoutDetails} }).then((res) => {
              dropin.handleAction(res)
            })
            
            // var air = {};
            // var sea = {};

            // air = {
            //   items : this.props.customerCheckout.checkoutDetails.itemArry.air,
            //   address : this.props.customerCheckout.checkoutDetails.air_address,
            //   note: this.props.customerCheckout.checkoutDetails.note_air,
            // }
            // sea  = {
            //   items : this.props.customerCheckout.checkoutDetails.itemArry.sea,
            //   address: this.props.customerCheckout.checkoutDetails.sea_address,
            //   note: this.props.customerCheckout.checkoutDetails.note_sea,
            // }

            // const adyenPayload = state;
            // if (state.data && !state.data.storePaymentMethod) {
            //   adyenPayload.data.storePaymentMethod = false;
            // }

            // const payload = {
            //   token: this.props.customerCheckout.checkoutDetails.token,
            //   air,
            //   sea,
            //   "insurance":this.props.customerCheckout.checkoutDetails.insurance,
            //   "payment_method": "credit_card",
            //   "payment_provider": 'adyen-dropin',
            //   "promo_code": this.props.customerCheckout.checkoutDetails.promo_code,
            //   'shipment_location_details': this.props.customerCheckout.checkoutDetails.shipment_location_details,
            //   'warehouse_id': this.props.customerCheckout.checkoutDetails.warehouse_id,
            //   'is_dangerous_sea': this.props.customerCheckout.checkoutDetails.is_dangerous_sea,
            //   'is_dangerous_air': this.props.customerCheckout.checkoutDetails.is_dangerous_air,
            //   'adyen-payment-method': adyenPayload,
            //   data: state.data,
            // }
          },
          onAdditionalDetails: (state, dropin) => {

          },
          paymentMethodsConfiguration: {
            card: {
              // Example optional configuration for Cards
              hasHolderName: true,
              holderNameRequired: true,
              enableStoreDetails: true,
              hideCVC: false, // Change this to true to hide the CVC field for stored cards
              name: 'Add a credit or debit card',
              // onSubmit: () => {
              //   console.log('test');
              // }, // onSubmit configuration for card payments. Overrides the global configuration.
            },
          },
        };
        const checkout = await AdyenCheckout(configuration);
        checkout.create('dropin', {
          showRemovePaymentMethodButton: true,
          onDisableStoredPaymentMethod: async (
            storedPaymentMethodId,
            resolve,
            reject,
          ) => {
           removeAdyenCard(storedPaymentMethodId, this.props.login.login.party.account_number).then((res)=> {
            resolve();
           }).catch((err) => {
              console.log(err)
              reject();
           })
          },
        }).mount(ReactDOM.findDOMNode(this.refs.adyenform));} catch (error) {
          console.log(error);
        }
    },

    handleLogout() {
        localStorage.removeItem('jwtToken');
        this.props.logout();
    },

    render() {
        return (
            <div className="home">

                <header className="site-header header-minimal">
                    <div className="container">

                        <div className="logo">
                            <Link to="/home" className="clearfix">
                                <div className="main-img"></div>
                            </Link>
                        </div>
                        <nav className="top-nav">
                            <ul>
                                <li className="dropdown has-sub">
                                    <a className="dropdown-toggle"
                                       data-toggle="dropdown">Hello {this.props.login.fetched ? this.props.login.login.party.first_name : null}&nbsp;
                                        <i className="fa fa-angle-down"></i></a>
                                    <ul className="sub sub-account dropdown-menu " style={{top: '80px'}}>
                                        <li><Link to="/cart"> Cart </Link></li>
                                        <li><Link to="/shipment"> Shipments</Link></li>
                                        <li><Link to="/account"> Account </Link></li>
                                        {this.props.parcelInfo.getParcel ? null : this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.length > 0 ?
                                            <li>
                                                <Link to="/prohibited">
                                                    Prohibited Items </Link>
                                            </li> : null : null}
                                        <li><Link to="/home" onClick={this.handleLogout}> Logout </Link></li>
                                    </ul>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </header>
                { this.state.isLoaderShown && <div style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left:0,
                    right: 0,
                    backgroundColor: 'rgba(255,255,255,0.6)',
                    display: 'flex',
                    justifyContent: 'center',
                    zIndex: 90,
                    alignItems: 'center'
                  }}>
                  <div className="loader">
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>}
                <div className="body-wrapper">
                  <div className="checkout container">
                    <div className="checkout-top text-center">
                      <div className="checkout-progress">
                      </div>
                    </div>
                    <div className="checkout-wrapper clearfix">
                      <div className="back-link">
                        <Link to="/cart"> &#60; Back to Cart</Link>
                      </div>
                        <div style={{ display: 'flex', justifyContent: 'center', margin: '0px 25px' }}>
                        <div className="clearfix">
                          
                          <div id="dropin-container" ref="adyenform"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Footer
                    currentPath={this.props.location.pathname}
                    currentYear={this.props.login.year}
                />

            </div>
        )
    },
});
export default AdyenPayment;



/** WEBPACK FOOTER **
 ** ./src/components/AdyenPayment.js
 **/